<template>
  <div class="GptRatingForm">
    <p class="GptRatingForm__content-title">
      <slot name="title">How would you rate this response?</slot>
    </p>
    <ul class="GptRatingForm__rating-options">
      <li
        v-for="option in ratingOptions"
        :key="option.value"
        class="GptRatingForm__rating-option"
      >
        <button
          class="GptRatingForm__rating-option-button"
          @click="$emit('update:modelValue', option.value)"
        >
          <UIIcon
            :key="modelValue >= option.value ? 'starSolid' : 'starRegular'"
            class="GptRatingForm__rating-option-button-icon"
            :class="{
              'GptRatingForm__rating-option-button-icon--unselected':
                modelValue < option.value,
            }"
            :name="modelValue >= option.value ? 'starSolid' : 'starRegular'"
          />
        </button>
        <div class="GptRatingForm__rating-option-button-label">
          {{ option.label }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import UIIcon from '../ui/icons/UIIcon.vue'

withDefaults(
  defineProps<{
    modelValue?: number
  }>(),
  {
    modelValue: 0,
  },
)
defineEmits(['update:modelValue'])

const ratingOptions = [
  {
    label: 'Very poor',
    value: 1,
  },
  {
    label: 'Poor',
    value: 2,
  },
  {
    label: 'Average',
    value: 3,
  },
  {
    label: 'Good',
    value: 4,
  },
  {
    label: 'Excellent',
    value: 5,
  },
]
</script>

<style lang="scss" scoped>
.GptRatingForm {
  .GptRatingForm__content-title {
    @include font-size-14px;
    color: var(--text-primary);
    margin-bottom: 0.25rem;
  }

  .GptRatingForm__rating-options {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 0.25rem;
  }

  .GptRatingForm__rating-option-button {
    border: 1px solid var(--interactive-border-default);
    border-radius: 0.25rem;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;

    &:hover {
      box-shadow: var(--shadow-xs);
    }
  }

  .GptRatingForm__rating-option-button-icon {
    --size: 1.5rem;
    --color: var(--icon-primary);

    &.GptRatingForm__rating-option-button-icon--unselected {
      --color: var(--icon-tertiary);
    }
  }

  .GptRatingForm__rating-option-button-label {
    @include font-size-10px;
    color: var(--text-tertiary);
    margin-top: 0.5rem;
    width: 100%;
    text-align: center;
  }
}
</style>
